export enum TLZEnvironment {
    dev = 'dev',
    qa = 'qa',
    preprod = 'preprod',
    prod = 'prod',
}
